import type { ReactNode } from 'react';
import classNames from '@rio-cloud/rio-uikit/classNames';
import { noop } from 'es-toolkit/compat';
import { isDesktop } from '@rio-cloud/rio-uikit/DeviceUtils';
import Icon from '@rio-cloud/rio-uikit/Icon';

import { colors } from '../../utils/colors';

export const PLAYGROUNG_BG_WHITE = 'bg-white';
export const PLAYGROUNG_BG_LIGHTEST = 'bg-lightest';
export const PLAYGROUNG_BG_LIGHTER = 'bg-lighter';
export const PLAYGROUNG_BG_LIGHT = 'bg-light';

const getColor = () => [...colors.playground.map(color => color.background)];
const getBgToggleClasses = (color: string) => classNames('rounded border width-15 height-15 cursor-pointer', color);
const getSize = () => ['phone', 'width', 'desktop'] as const;

type PlaygroundHeaderProps = {
    availableColors: ReactNode;
    onBackgroundChange: (newColor: string) => void;
    onFeedback: () => void;
    onPlaygroundSizeChange: (x: 'phone' | 'width' | 'desktop') => void;
    onDetach: () => void;
    showFeedbackButton: boolean;
    showSizeButtons: boolean;
    showBackgroundButtons: boolean;
};

export const PlaygroundHeader = (props: PlaygroundHeaderProps) => {
    const {
        availableColors,
        onBackgroundChange = noop,
        onFeedback,
        onPlaygroundSizeChange,
        onDetach,
        showFeedbackButton = true,
        showSizeButtons = true,
        showBackgroundButtons = true,
    } = props;

    return (
        <div className='playground-header rounded-top'>
            {availableColors ? (
                <div className='display-flex flex-column'>
                    {availableColors}
                    <span className='playground-title'>Available Variations</span>
                </div>
            ) : (
                <span className='separator' />
            )}
            <div className='display-flex gap-20'>
                {showFeedbackButton && (
                    <div className='display-flex flex-column align-items-center'>
                        <span
                            onClick={onFeedback}
                            className='cursor-pointer text-color-light hover-text-color-darkest uikit-icon icon-warning-sign'
                        />
                        <span className='playground-title'>Feedback</span>
                    </div>
                )}
                <div className='display-flex flex-column align-items-center'>
                    <span
                        onClick={onDetach}
                        className='cursor-pointer text-color-light hover-text-color-darkest uikit-icon icon-new-window'
                    />
                    <span className='playground-title'>Figma</span>
                </div>
                {showSizeButtons && isDesktop() && (
                    <div className='display-flex flex-column align-items-center'>
                        <div className='display-flex gap-5'>
                            {getSize().map(icon => (
                                <span
                                    className='cursor-pointer text-color-light hover-text-color-darkest display-flex'
                                    key={icon}
                                    onClick={() => {
                                        onPlaygroundSizeChange(icon);
                                    }}
                                >
                                    <Icon iconName={icon} />
                                </span>
                            ))}
                        </div>
                        <span className='playground-title'>Size</span>
                    </div>
                )}
                {showBackgroundButtons && (
                    <div className='display-flex flex-column align-items-end'>
                        <div className='display-flex column-gap-5 justify-content-end'>
                            {getColor().map(color => (
                                <span
                                    className={`${getBgToggleClasses(color)} hover-scale-105`}
                                    key={color}
                                    onClick={() => onBackgroundChange(color)}
                                />
                            ))}
                        </div>
                        <span className='playground-title'>Background</span>
                    </div>
                )}
            </div>
        </div>
    );
};
